import { ILocalizedMenuEntry } from 'state/unified-menu/types';

import { MultipliersSelections } from '../../product-wizard/types';
import { IModifier } from '../modifier/types';

export type CustomizationRenderItem = {
  item: ILocalizedMenuEntry;
  index: number;
  rowIndex: number;
};

// Order Matters for UI!
export enum DrinkCategory {
  SOFTS,
  SHAKES,
  FROZENS,
  OTHERS,
}

export enum ComboSlotType {
  DRINKS = 'drinks',
  SIDES = 'sides',
  PICKER_ASPECT = 'pickerAspect',
}

// @TODO BKPE-24875: Next step will be to have these as traslation keys for different languages.
export const CATEGORY_LABEL_KEY: Record<DrinkCategory, string> = {
  [DrinkCategory.SOFTS]: 'soft drinks',
  [DrinkCategory.SHAKES]: 'shakes',
  [DrinkCategory.FROZENS]: 'frozens',
  [DrinkCategory.OTHERS]: 'others',
};

export type SelectModifierFn = (selections: MultipliersSelections, modifier: IModifier) => void;
